import { Button, Checkbox } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from 'dayjs';
import { TFunction } from "i18next";

import { StatusTypes } from "./warrantyContent";
import NormalTag from "../../../../components/tags/NormalTag";
import { WarrantyListResponse, ProductGroup } from "../../../../graphql/operations/@types";
import { NormalTagTypes } from "../../../../types/types";

export function createColumns(
  handleDetailClick: (applicationId: number) => void,
  handleCheckBoxTitleChange: any,
  handleCheckBoxRowChange: any,
  isAllSelect: boolean,
  selectData: number[],
  trans: TFunction
): ColumnsType<WarrantyListResponse> {
  return [
    {
      title: (
        <Checkbox
          checked={isAllSelect}
          indeterminate={selectData.length > 0 && !isAllSelect}
          onChange={handleCheckBoxTitleChange}
        />
      ),
      key: "check",
      dataIndex: "applicationId",
      render: (applicationId: number) => (
        <Checkbox
          checked={selectData.includes(applicationId)}
          onChange={() => handleCheckBoxRowChange(applicationId)}
          onClick={(e) => e.stopPropagation()}
        />
      ),
      width: 55,
    },
    {
      title: trans("clubApp:warranty.applicationNo"),
      dataIndex: 'applicationNo',
      key: 'applicationNo',
      width: 150,
    },
    {
      title: trans("clubApp:warranty.applicationDate"),
      dataIndex: 'applicationDate',
      key: 'applicationDate',
      width: 150,
      render: (value) => value ? dayjs(value).format('YYYY/MM/DD HH:mm') : "",
      defaultSortOrder: 'ascend',
      sorter: (a, b) =>
        dayjs(a.applicationDate).valueOf() -
        dayjs(b.applicationDate).valueOf(),
    },
    {
      title: trans("clubApp:warranty.ACNO"),
      dataIndex: 'accountNo',
      key: 'accountNo',
      width: 100,
    },
    {
      title: trans("clubApp:warranty.itemQty"),
      dataIndex: 'itemQty',
      key: 'itemQty',
      width: 130,
    },
    {
      title: trans("common:common.status"),
      key: 'status',
      width: 130,
      render: (_, record) => {
        if (record.status === StatusTypes.Awaiting) return <NormalTag type={NormalTagTypes.AWAITING} />;
        else if (record.status === StatusTypes.Complete) return <NormalTag type={NormalTagTypes.COMPLETE} />;
        else if (record.status === StatusTypes.Canceled) return <NormalTag type={NormalTagTypes.CANCELED} />;
      },
    },
    {
      title: trans("clubApp:warranty.productCategory"),
      dataIndex: 'categoryNames',
      key: 'categoryNames',
      width: 400,
    },
    {
      title: trans("common:common.actions"),
      dataIndex: "",
      key: "",
      width: 100,
      fixed: 'right',
      render: (_, record) => (
        <div className="flex gap-4">
          <Button type="link" className="w-9 p-0" onClick={() => handleDetailClick(record.applicationId)}>
            {record.status === StatusTypes.Awaiting ? trans("common:button.edit") : trans("common:button.view")}
          </Button>
        </div>
      ),
    },
  ];
}

export function createDetailColumns(trans: TFunction): ColumnsType<ProductGroup> {
  return [
    {
      title: trans("clubApp:warranty.productId"),
      dataIndex: 'productId',
      key: 'productId',
      width: 150,
    },
    {
      title: trans("clubApp:warranty.productItemName"),
      dataIndex: 'categoryName',
      key: 'categoryName',
      render: (_, record) => (
        <div>
          <div>{record.productName}</div>
          <div className="table-content-remark">
            {record.categoryName + " > " + record.subCategoryName}
          </div>
        </div>
      ),
    },
    {
      title: trans("clubApp:warranty.reasonAndDetail"),
      key: 'reasonText',
      width: 250,
      render: (_, record) => (
        <div>
          <div>{record.reasonText + " :"}</div>
          <div style={{ whiteSpace: "pre-wrap", marginTop: 4 }}>{record.reasonMemo}</div>
        </div>
      ),
    },
  ]
};

export function createPrintColumns(trans: TFunction): ColumnsType<ProductGroup> {
  return [
    {
      title: trans("clubApp:warranty.productId"),
      dataIndex: 'productId',
      key: 'productId',
      width: 120,
    },
    {
      title: trans("clubApp:warranty.productItemName"),
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: trans("clubApp:warranty.defectDetails"),
      key: 'reasonText',
      width: 200,
      render: (_, record) => (
        <div>
          <div>{record.reasonText + " :"}</div>
          <div style={{ whiteSpace: "pre-wrap" }}>{record.reasonMemo}</div>
        </div>
      ),
    },
  ]
};

